/**
 * @file document-cells.tsx
 * @description Общие ячейки реестров складских документов — приёмок,
 * перемещений и списаний (phase19.31, зона «Склад»; SC43, SC46).
 *
 * Номер документа — код: моноширинным и в одну строку (раньше «WO-2026-» и
 * «000002» переносились). Количества — табличными цифрами обычным шрифтом.
 * Дата — по поясу магазина (SC31), под ней — кто создал. Итоги строкой
 * («3 позиции · 12 шт») — в `document-totals.ts`.
 */

import { TwoLineCell } from "../../ui/TwoLineCell";
import { formatShopDate } from "../../../lib/shop-time";

/** Номер документа одной строкой. */
export function DocumentNumber({ value }: { value: string }) {
  return (
    <span title={value} className="type-body block truncate whitespace-nowrap font-mono text-on-surface">
      {value}
    </span>
  );
}

/** «Дата / автор» — двухстрочная ячейка «Создано». */
export function CreatedCell({ at, by }: { at: string; by?: string | null }) {
  return <TwoLineCell primary={formatShopDate(at)} secondary={by ?? undefined} />;
}

/** Число справа в таблице — табличными цифрами. */
export function NumberCell({ value }: { value: number | string }) {
  return <span className="tabular-nums">{value}</span>;
}
